import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectUnderwriting = createSelector(
  selectLoanApplication,
  ({ underwriting }) => underwriting,
);

export const selectUnderwritingExpirationDates = createSelector(
  selectUnderwriting,
  ({ expirationDates }) => expirationDates,
);

export const selectUnderwritingNotes = createSelector(selectUnderwriting, ({ notes }) => notes);

export const selectUnderwritingQualificationDetails = createSelector(
  selectUnderwriting,
  ({ qualificationDetails }) => qualificationDetails,
);
